import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BeforeBeginGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // const { QUERY_PARAM } = ROUTE.VERIFICATION;
    //
    // const code = route.queryParamMap.get(QUERY_PARAM.CODE);
    //
    // if (!code) {
    //   return this.router.createUrlTree([ROUTE.ERROR.MAIN, ROUTE.ERROR.FORBIDDEN]);
    // }

    return true;
  }
}
